import React, { useEffect } from 'react';
import ReactDOM from "react-dom";
import Cookies from "universal-cookie";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-boost";
import { InMemoryCache } from "apollo-cache-inmemory";
//import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';
//import { ErrorBoundary } from 'react-error-boundary';
import {
  BrowserRouter,
  Route,
  Switch,
  useLocation,
  withRouter,
  Redirect
} from 'react-router-dom'
import { createHttpLink } from "apollo-link-http";
import App from "./App";
import Frontpage from "./Frontpage";
import Event from "./single/event_from_wp";
import Notikums from "./single/notikums";
import Blogs from "./single/blogs";
import Draugi from "./single/draugi";
import KlaraCampaign from "./single/klara";
import Faq from "./single/faq";
import Skolas14 from "./single/skolas14";
import Teh100 from "./single/teh100";
import Dj from "./single/dj";
import Menu from "./single/menu";
import Pieteikums from "./single/pieteikums";
import Standup from "./single/standup";
import Customer from "./single/customer";
import Galerija from "./single/galerija";
import Config from "./config";

import ReactGA from 'react-ga';

import ReactPixel from 'react-facebook-pixel';




const advancedMatching = {
  em: 'info@kanepes.lv'
}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};
ReactPixel.init('3815465585239278', advancedMatching, options);

ReactPixel.pageView(); // For tracking page view


ReactGA.initialize('UA-91684860-1');
ReactGA.pageview(window.location.pathname + window.location.search);



function _ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname]);
  return props.children
}
const ScrollToTop = withRouter(_ScrollToTop);

// if (window.location.toString().indexOf("/lv") > -1 || window.location.toString().indexOf("/en") > -1) {

// }






// console.log(baseRouteUrl + window.location.pathname);
//console.log(cookies.get("lang"));
//console.log(window.location.toString());

const client = new ApolloClient({
  link: createHttpLink({
    uri: Config.gqlUrl
  }),
  cache: new InMemoryCache()
});



function RenderDom() {

  useEffect(() => {


    const cookies = new Cookies();
    if (cookies.get("lang") === null || cookies.get("lang") === undefined || cookies.get("lang") === "null" || cookies.get("lang") === "undefined") {
      console.log(cookies.get("lang"));
      cookies.set("lang", "LV", { path: "/", maxAge: 365 });
      window.history.pushState('', '', "/" + cookies.get("lang").toLowerCase() + window.location.pathname);
    } else if (cookies.get("lang") === "LV" && window.location.toString().indexOf("/lv") > -1) {
      cookies.set("lang", "LV", { path: "/" });

    } else if (cookies.get("lang") === "EN" && window.location.toString().indexOf("/en") > -1) {
      cookies.set("lang", "EN", { path: "/" });
    } else if (cookies.get("lang") === "LV" && window.location.toString().indexOf("/en") > -1) {
      cookies.set("lang", "EN", { path: "/" });
    } else if (cookies.get("lang") === "EN" && window.location.toString().indexOf("/lv") > -1) {
      cookies.set("lang", "LV", { path: "/" });
    } else if ((cookies.get("lang") === "EN" || cookies.get("lang") === "LV") && window.location.toString().indexOf("/en") === -1 && window.location.toString().indexOf("/lv") === -1) {
      var baseRouteUrl = "/" + cookies.get("lang").toLowerCase();
      window.history.pushState('', '', baseRouteUrl + window.location.pathname);
    } else {

    }

  });

  

  return (

    <BrowserRouter>
      <ScrollToTop>
        <ApolloProvider client={client}>
          <App />
          <Switch>
            <Route exact path={["/", "/lv/", "/en/"]} component={Frontpage} />
            <Route exact path="/telpas">
              <Redirect to={"/lv/#telpas_wrap"} />
            </Route>
            <Route exact path="/kolo">
              <Redirect to={"/lv/notikumi/kolo"} />
            </Route>
            <Route exact path="/lv/kolo">
              <Redirect to={"/lv/notikumi/kolo"} />
            </Route>
            <Route exact path="/en/kolo">
              <Redirect to={"/en/notikumi/kolo"} />
            </Route>
            <Route path={["/notikumi/:slug", "/lv/notikumi/:slug", "/en/notikumi/:slug"]} component={Notikums} />
            {/* <Route path={["/event/:id", "/lv/event/:id", "/en/event/:event"]} component={Event} /> */}
            {/* <Route path={["/event/:slug/:id", "/lv/event/:slug/:id", "/en/event/:slug/:id"]} render={(props) => <Event {...props} />} /> */}
            <Route path={["/event/:slug", "/lv/event/:slug", "/en/event/:slug"]} render={(props) => <Event {...props} />} />
            <Route exact path={["/klara/", "/lv/klara/", "/en/klara/"]} component={KlaraCampaign} />
            <Route path={["/blogi/:slug", "/lv/blogi/:slug", "/en/blogi/:slug"]} component={Blogs} />
            <Route path={["/foto/:slug", "/lv/foto/:slug", "/en/foto/:slug"]} component={Galerija} />
            <Route path={["/draugi", "/lv/draugi", "/en/draugi"]} component={Draugi} />
            <Route path={["/faq-klara", "/lv/faq-klara", "/en/faq-klara"]} component={Faq} />
            <Route path={["/skolas14", "/lv/skolas14", "/en/skolas14"]} component={Skolas14} />
            <Route path={["/djakademija", "/lv/djakademija", "/en/djakademija"]} component={Dj} />
            <Route path={["/pieteikums", "/lv/pieteikums", "/en/pieteikums"]} component={Pieteikums} />
            <Route path={["/teh100", "/lv/teh100", "/en/teh100"]} component={Teh100} />
            <Route path={["/menu", "/lv/menu", "/en/menu"]} component={Menu} />
            <Route path={["/stendaps", "/lv/stendaps", "/en/stendaps"]} component={Standup} />
            <Route path={["/manage", "/lv/manage", "/en/manage"]} component={Customer} />
            <Route path="*">
              <Redirect to={"/"} />
            </Route>
          </Switch>
        </ApolloProvider>
      </ScrollToTop>
    </BrowserRouter>
  );
}

ReactDOM.render(<RenderDom />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
